import { withPrefix } from 'gatsby';
import * as React from 'react';
export default {
  withPrefix,
  React
};